import {all, call, put, takeLatest, takeLeading} from 'redux-saga/effects';
import {actions, ActionType} from './action';
import {getCompleteContents, getDayContent, getNewContents} from './apiGet';
import {actions as commonActions} from '../../../common/state/action';
import callApi from '../../../common/util/api';
import {makeFetchSaga} from '../../../common/util/fetch';
import {typedSelect} from '../../../common/util/saga';
import {toSnakeCase} from '../../../common/util/string';
import {callApiContentLike} from '../../../commonSub/state/callApi';
import {DEFAULT_GENRE_KEY} from '../../common/common';
import {fetchCompletedGenres} from '../../common/state/callApi';

function* fetchNewContents(
  action: ReturnType<typeof actions.fetchNewContents>
) {
  const {page} = action.payload;
  const {success, data} = yield call(callApi, {
    url: '/section/v1/timetables/days',
    params: {placement: 'timetable_new'},
  });
  if (success && data) {
    yield put(actions.setNewContents(page, getNewContents(data)));
  }
}

function* fetchCompletedContents(
  action: ReturnType<typeof actions.fetchCompletedContents>
) {
  const {page, genre} = action.payload;
  const selectedGenre = yield* typedSelect(
    state => state.timeTable.genre[page].selectedKey
  );
  const {success, data} = yield call(callApi, {
    url: '/section/v1/timetables/days',
    params: {
      placement: genre || selectedGenre || DEFAULT_GENRE_KEY,
    },
  });
  if (success && data) {
    const {bigContent, contents} = getCompleteContents(data);
    yield put(
      actions.setCompletedContents({
        page,
        bigContent,
        contents,
      })
    );
  }
}

function* fetchWeekday(action: ReturnType<typeof actions.fetchWeekday>) {
  const {key, day} = action.payload;
  const currentSort = yield* typedSelect(
    state => key || state.timeTable.sortKeyByDayTab
  );
  const placement = `timetable_${day}${
    currentSort !== 'recommend' ? `_${toSnakeCase(currentSort)}` : ''
  }`;
  const {success, data} = yield call(callApi, {
    url: 'section/v1/timetables/days',
    params: {placement},
  });

  if (success && data) {
    yield put(
      actions.setDayContent({
        day,
        sortKey: currentSort,
        item: getDayContent(data[0]),
      })
    );
  }
}
function* fetchNewContentLike(
  action: ReturnType<typeof actions.fetchNewContentLike>
) {
  const {contentId, index, isLike} = action.payload;
  const {success} = yield* callApiContentLike({
    id: contentId,
    isOn: isLike,
  });
  if (success) {
    yield put(actions.setNewContentLike({index, isLike}));
    yield put(commonActions.setContentLike({id: contentId, isLike}));
  }
}

export default function* saga() {
  yield all([
    takeLatest(
      ActionType.FetchWeekday,
      makeFetchSaga({
        fetchSaga: fetchWeekday,
        canCache: false,
      })
    ),
    takeLatest(
      ActionType.FetchNewContents,
      makeFetchSaga({
        fetchSaga: fetchNewContents,
        canCache: false,
      })
    ),
    takeLatest(
      ActionType.FetchCompletedContents,
      makeFetchSaga({
        fetchSaga: fetchCompletedContents,
        canCache: false,
      })
    ),
    takeLeading(
      ActionType.FetchCompletedGenres,
      makeFetchSaga({
        fetchSaga: fetchCompletedGenres,
        canCache: false,
      })
    ),
    takeLatest(
      ActionType.FetchNewContentLike,
      makeFetchSaga({
        fetchSaga: fetchNewContentLike,
        canCache: false,
      })
    ),
  ]);
}
